/* eslint-disable @typescript-eslint/no-explicit-any */
import { FC, SetStateAction, useLayoutEffect, useState } from 'react';
import { ApolloProvider } from '@apollo/client';
import cn from 'classnames';

import { Modal } from '@/components/common/Modal';
import { getApolloClient } from '@/utils/apollo-client';
import { IconButton } from '@/components/buttons/IconButton';

const client = getApolloClient();

export interface FormModalProps {
  isOpen: boolean;
  closeModal: () => void;
  text: string;
}

export const FormModal: FC<FormModalProps> = ({ isOpen, closeModal, text }) => {
  const [isGrayscale, setIsGrayscale] =
    useState<SetStateAction<boolean>>(false);

  useLayoutEffect(() => {
    const grayscale = localStorage.getItem('grayscale');
    if (grayscale) {
      setIsGrayscale(JSON.parse(grayscale));
    }
  }, []);

  return (
    <ApolloProvider client={client}>
      <Modal
        closeModal={closeModal}
        isOpen={isOpen}
        className={cn('h-fit pb-10	pt-16', {
          grayscale: isGrayscale,
        })}
      >
        <p
          className={
            'bold !mb-0 text-center text-xl font-bold dark:text-darkFullLight dark:text-darkFullLight  md:text-xxl'
          }
          dangerouslySetInnerHTML={{ __html: text }}
        />
        <IconButton
          icon="close"
          className="absolute right-0 top-0 inline-flex h-12 w-12 items-center justify-center text-primaryDark transition-colors duration-300"
          onClick={closeModal}
        />
      </Modal>
    </ApolloProvider>
  );
};
